import Field from "./fields";
import { ObjectRelation } from "./relation";
import { View } from "./views";
import { CompozzIcon, LucideIconType } from "./CompozzIcon";
import ObjectActionDto from "./ObjectAction";

interface ObjectDto {
    _key: string;
    name: string;
	order: number;
	icon: CompozzIcon | null;
}

interface ObjectResponse {
	objectInfos: ObjectInfos[];
	sharedObjectInfos: SharedObjectInfos[];
}

// ObjectInfos is the response of the GetObject endpoint
interface ObjectInfos {
	object: ObjectDto;
	fields: Field[];
	relations: ObjectRelation[];
	views: View[];
	actions: ObjectActionDto[];
}

// SharedObjectInfos is the response of the SharedObjects endpoint
interface SharedObjectInfos {
	wsKey: string;
	objectInfos: ObjectInfos[];
}

export const defaultObjectIcon: CompozzIcon = {
    name: "database",
    type: LucideIconType
}

interface DuplicateObjectRequest {
	workspaceKey: string;
	objectKey: string;
	objectName: string | undefined;
	objectOrder: number | undefined;
}

export type { ObjectDto, ObjectInfos, SharedObjectInfos, ObjectResponse, DuplicateObjectRequest };
